import styled from "styled-components";
import { Button, SwipeableDrawer, TextField, Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";

/* Fica "grudado" no topo enquanto a lista rola */
export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #f7f9fc; /* mesma cor do fundo da tela */
  padding: 4px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SearchInput = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    background-color: #ffffff;
    border-radius: 12px;
  }

  & input {
    font-size: 16px; /* >= 16px evita o zoom automático do iOS ao focar */
    padding: 12px 4px;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.colors.base};
  }
`;

export { ChipRow, Chip } from "../../utils/globalStyles/chips";

export const ClearButton = styled.button`
  align-self: flex-end;
  border: none;
  background: none;
  color: ${theme.colors.base};
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  padding: 0 4px;
  cursor: pointer;
`;

/* Bottom sheet do período personalizado */
export const Sheet = styled(SwipeableDrawer)`
  & .MuiDrawer-paper {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    border-radius: 20px 20px 0 0;
    padding: 12px 24px calc(24px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }
`;

export const SheetHandle = styled.div`
  width: 40px;
  height: 5px;
  border-radius: 3px;
  background-color: #dddddd;
  margin: 0 auto 16px;
`;

export const SheetTitle = styled(Typography)`
  font-weight: 800 !important;
  font-size: 18px !important;
  color: #333333;
  margin-bottom: 16px !important;
`;

export const DateRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
`;

export const DateField = styled.label`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: ${theme.colors.base};

  & input {
    font-size: 16px;
    font-family: inherit;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    background-color: #f9f9f9;
    color: #333333;
    min-height: 48px;
    box-sizing: border-box;
    width: 100%;
  }
`;

export const SheetActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const SecondaryButton = styled(Button)`
  flex: 1;
  height: 48px;
  border-radius: 10px !important;
  color: #666666 !important;
  font-weight: 700 !important;
  text-transform: none !important;
  background-color: #f1f1f1 !important;
`;

export const PrimaryButton = styled(Button)`
  flex: 1;
  height: 48px;
  border-radius: 10px !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  background-color: ${theme.colors.base} !important;

  &.Mui-disabled {
    opacity: 0.5;
  }
`;
